(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[459],{

/***/ 37697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(78951);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(58408);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(38726);
/* harmony import */ var _analytics_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45003);
/* harmony import */ var _analytics_events_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45048);
/* harmony import */ var _components_app_authForms_layout_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61098);
/* harmony import */ var _components_app_authForms_loginForm_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49985);
/* harmony import */ var _components_app_layout_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37356);
/* harmony import */ var _components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90836);
/* harmony import */ var _components_uielements_hr__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51912);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25643);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10606);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36304);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60738);





















var Login = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(Login, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(Login);
    function Login() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(this, Login);
        return _super.apply(this, arguments);
    }
    var _proto = Login.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if ((0,_utils_auth__WEBPACK_IMPORTED_MODULE_12__/* .userLoggedIn */ .nD)()) {
            void next_router__WEBPACK_IMPORTED_MODULE_2___default().push(_constants_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.HOMEPAGE */ .Z6.HOMEPAGE);
        }
    };
    _proto.render = function render() {
        var _props = this.props, router = _props.router, webConfig = _props.webConfig;
        var signupReferrer = (0,_utils_global__WEBPACK_IMPORTED_MODULE_13__/* .deriveReferrer */ .k5)(router);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_layout_index__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            backgroundOverride: true,
            disabled: (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_14__/* .safelyGetConfig */ .K6)(webConfig, "accounts.disable_accounts"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_authForms_layout_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledAuthPageLayout */ .e, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_app_authForms_layout_styles__WEBPACK_IMPORTED_MODULE_6__/* .StyledAuthPageContent */ .x, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            tag: "h1",
                            accessor: "login.header",
                            html: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            tag: "h3",
                            accessor: "login.subheader",
                            html: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_hr__WEBPACK_IMPORTED_MODULE_10__/* .StyledHr */ .n, {
                            background: "transparent"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_app_authForms_loginForm_index__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: {
                                    pathname: _constants_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.FORGOT_PASSWORD */ .Z6.FORGOT_PASSWORD
                                },
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    onClick: function() {
                                        return (0,_analytics_events__WEBPACK_IMPORTED_MODULE_4__/* .genericEventHandler */ .O)(_analytics_events_constants__WEBPACK_IMPORTED_MODULE_5__/* .GlobalEvents.AUTH__CLICK_FORGOT_PASSWORD */ .x.AUTH__CLICK_FORGOT_PASSWORD);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        accessor: "forgot_password.prompt"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_hr__WEBPACK_IMPORTED_MODULE_10__/* .StyledHr */ .n, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    accessor: "signup.prompt",
                                    html: true
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.SIGN_UP */ .Z6.SIGN_UP, "?referrer=").concat(signupReferrer),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        onClick: function() {
                                            return (0,_analytics_events__WEBPACK_IMPORTED_MODULE_4__/* .genericEventHandler */ .O)(_analytics_events_constants__WEBPACK_IMPORTED_MODULE_5__/* .GlobalEvents.AUTH__CLICK_SIGN_UP */ .x.AUTH__CLICK_SIGN_UP);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cmsConfig_stringAccessor__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            accessor: "signup.cta"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    };
    Login.getInitialProps = function getInitialProps() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                return [
                    2,
                    {}
                ];
            });
        })();
    };
    return Login;
}(react__WEBPACK_IMPORTED_MODULE_3__.Component);
/* harmony default export */ __webpack_exports__["default"] = ((0,redux__WEBPACK_IMPORTED_MODULE_20__/* .compose */ .qC)(next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(Login));


/***/ }),

/***/ 61098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ StyledAuthPageLayout; },
/* harmony export */   "x": function() { return /* binding */ StyledAuthPageContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: calc(100vh - ",
        "px);\n\n  @media (max-width: 767px) {\n    background-color: ",
        ";\n    min-height: calc(100vh - ",
        "px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAuthPageLayout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44565f4c-0"
})(_templateObject(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT * 2, function(param) {
    var theme = param.theme;
    return theme.auth_page.background_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT * 2);
var _background_color, _border_color, _border_radius, _background_color1;
var StyledAuthPageContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44565f4c-1"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.auth_page.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid ".concat((_border_color = theme.auth_page.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.auth_page.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        margin: "0 auto",
        maxWidth: "".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MEDIUM_CONTENT */ ._.MEDIUM_CONTENT, "px"),
        padding: "40px 20px",
        textAlign: "center",
        width: "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.font)), {
        h1: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            margin: 0
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.secondary_font)),
        h3: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.font, [
            "color",
            "font_family",
            "font_size",
            "font_style",
            "line_height", 
        ])), {
            fontWeight: "normal",
            margin: 0
        }),
        p: {
            margin: "20px 0 0"
        },
        a: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            textDecoration: "underline",
            transition: "opacity 0.2s linear"
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.tertiary_font)), {
            "&:hover": {
                opacity: 0.7
            }
        }),
        "@media (max-width: 767px)": {
            borderColor: (_background_color1 = theme.auth_page.background_color) !== null && _background_color1 !== void 0 ? _background_color1 : "transparent"
        }
    });
});


/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ StyledHr; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  display: block;\n  height: 1px;\n  border: 0;\n  margin: ",
        "px 0;\n  padding: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledHr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-d8fdad27-0"
})(_templateObject(), function(param) {
    var background = param.background, theme = param.theme;
    return background || theme.global.primary_border_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.MEDIUM */ .jl.MEDIUM);


/***/ }),

/***/ 18368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58408);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3176);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56580);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19663);








var ReCaptcha = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ReCaptcha, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ReCaptcha);
    function ReCaptcha() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, ReCaptcha);
        return _super.apply(this, arguments);
    }
    var _proto = ReCaptcha.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.onRef(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)());
    };
    _proto.render = function render() {
        var ref, ref1, ref2, ref3;
        var _props = this.props, forwardRef = _props.forwardRef, organization = _props.organization, action = _props.action;
        var sitekey = organization === null || organization === void 0 ? void 0 : (ref = organization.external_auth) === null || ref === void 0 ? void 0 : (ref1 = ref.captcha) === null || ref1 === void 0 ? void 0 : ref1.site_key;
        var actions = (organization === null || organization === void 0 ? void 0 : (ref2 = organization.external_auth) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.captcha) === null || ref3 === void 0 ? void 0 : ref3.actions) || [];
        // Ensures we show captcha conditionally to companies that have it enabled.
        if (!sitekey || !actions.includes(action)) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            ref: forwardRef,
            onError: _utils_errorReporter__WEBPACK_IMPORTED_MODULE_7__/* .captureException */ .Tb,
            sitekey: sitekey,
            badge: "bottomright",
            size: "invisible"
        });
    };
    return ReCaptcha;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var mapStateToProps = function(state) {
    return {
        organization: state.app.organization
    };
};
var connector = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__.connect)(mapStateToProps);
/* harmony default export */ __webpack_exports__["Z"] = (connector(ReCaptcha));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,513,372,443,89,588,356,985,774,888,179], function() { return __webpack_exec__(37697); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);